export default {"src":"/_next/static/media/help.e1ecf36a.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};